import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const DOW = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
const MON = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

// Reloj anclado a la hora de Guatemala (UTC-6), independiente de la zona del navegador.
const gtNow = () => new Date(Date.now() - 6 * 3600 * 1000);

export const GtClock = () => {
  const [now, setNow] = useState(gtNow());
  useEffect(() => {
    const id = setInterval(() => setNow(gtNow()), 1000);
    return () => clearInterval(id);
  }, []);
  const p = (n) => String(n).padStart(2, "0");
  const dateStr = `${DOW[now.getUTCDay()]} ${now.getUTCDate()} ${MON[now.getUTCMonth()]} ${now.getUTCFullYear()}`;
  const timeStr = `${p(now.getUTCHours())}:${p(now.getUTCMinutes())}:${p(now.getUTCSeconds())}`;
  return (
    <div
      className="hidden md:flex items-center gap-2 rounded-sm border border-border/60 bg-muted/40 px-2.5 py-1.5"
      title="Hora de Guatemala (UTC-6)"
      data-testid="gt-clock"
    >
      <Clock className="h-4 w-4 text-primary shrink-0" />
      <div className="leading-none">
        <p className="text-[13px] font-mono font-semibold text-foreground tabular-nums" data-testid="gt-clock-time">{timeStr}</p>
        <p className="text-[9px] uppercase tracking-wider text-muted-foreground">GT · {dateStr}</p>
      </div>
    </div>
  );
};
